import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGripDots = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 8 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 1,
			cy: 1,
			r: 1,
			fill: "#C6C3BB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 1,
			r: 1,
			fill: "#C6C3BB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1,
			cy: 6,
			r: 1,
			fill: "#C6C3BB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 6,
			r: 1,
			fill: "#C6C3BB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1,
			cy: 11,
			r: 1,
			fill: "#C6C3BB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 11,
			r: 1,
			fill: "#C6C3BB"
		})
	]
});
export default SvgGripDots;
